<template>
    <div id="app">
        <sakali-header></sakali-header>
        <keep-alive>
            <router-view/>
        </keep-alive>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Header from './components/Navigation'

    export default {
        components: {
            'sakali-header': Header
        },
        computed: {
            ...mapGetters(['version'])
        },
        methods: {
            ...mapActions(['messageAction']),
            message(msg) {
                this.messageAction(msg)
            }
        },
        created(){
            // load configuration info from server
            this.$store.dispatch('loadConfigurationAction')
            // send version event to GA
            // this.$ga.event('version', this.version, this.version, '0');
        }
    }
</script>

